var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTheme(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5833 0.208328L14.45 0.233328L10 1.95833L5 0.208328L0.3 1.79166C0.125 1.84999 0 1.99999 0 2.19166V14.7917C0 15.025 0.183333 15.2083 0.416667 15.2083L0.55 15.1833L5 13.4583L10 15.2083L14.7 13.625C14.875 13.5667 15 13.4167 15 13.225V0.624995C15 0.391662 14.8167 0.208328 14.5833 0.208328ZM5.83333 2.26666L9.16667 3.43333V13.15L5.83333 11.9833V2.26666ZM1.66667 3.09166L4.16667 2.24999V12L1.66667 12.9667V3.09166ZM13.3333 12.325L10.8333 13.1667V3.42499L13.3333 2.45833V12.325Z",
    fill: "#6E6E6E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTheme);
export default __webpack_public_path__ + "static/media/icon_theme.8264f73607167f557d49d915f44fbf96.svg";
export { ForwardRef as ReactComponent };